export const MODAL_MAIN = 'main';
export const MODAL_SHEET = 'sheet';
export const MODAL_LOGIN = 'login';
export const MODAL_FREE_ACCOUNT_SIGNUP = 'free-account-signup';
export const MODAL_RESERVATION = 'reservation';
export const MODAL_USER_CARD_SHEET = 'userCardSheet';
export const MODAL_EVENT_CONTENT = 'eventContent';

export type ModalKey =
    | typeof MODAL_MAIN
    | typeof MODAL_SHEET
    | typeof MODAL_LOGIN
    | typeof MODAL_FREE_ACCOUNT_SIGNUP
    | typeof MODAL_RESERVATION
    | typeof MODAL_USER_CARD_SHEET
    | typeof MODAL_EVENT_CONTENT;

export type ModalEventContentDate =  {
    slug: string;
}

export type ModalData = {
    [MODAL_EVENT_CONTENT]?: ModalEventContentDate;
    [MODAL_MAIN]?: unknown;
    [MODAL_SHEET]?: unknown;
    [MODAL_LOGIN]?: unknown;
    [MODAL_FREE_ACCOUNT_SIGNUP]?: unknown;
    [MODAL_RESERVATION]?: unknown;
    [MODAL_USER_CARD_SHEET]?: unknown;
}

export type ModalPayloadWithData =
    | {
        name: typeof MODAL_EVENT_CONTENT;
        data: ModalEventContentDate;
    }
    | {
        name:
            | typeof MODAL_MAIN
            | typeof MODAL_SHEET
            | typeof MODAL_LOGIN
            | typeof MODAL_FREE_ACCOUNT_SIGNUP
            | typeof MODAL_RESERVATION
            | typeof MODAL_USER_CARD_SHEET;
        data: any;
    }

export type ModalPayload =
    | ModalKey
    | ModalPayloadWithData;

export const useModalStore = defineStore('modal', () => {
    const activeModals = ref<{[key: string]: boolean}>({});
    const data = ref<ModalData>({});

    function close(payload: ModalKey) {
        if (activeModals.value?.[payload]) {
            delete activeModals.value?.[payload];
        }

        if (data.value?.[payload]) {
            delete data.value?.[payload];
        }

        document.body.setAttribute(`data-modal-${payload}-open`, 'false');

        if (Object.values(activeModals.value).filter(value => value).length === 0) {
            document.body.removeAttribute('data-prevent-scrolling');
        }
    }

    function closeAll() {
        activeModals.value = {};
        data.value = {};
    }

    function open(payload: ModalPayload) {
        const modalName = typeof payload === 'string'
            ? payload
            : payload.name;

        if (typeof payload !== 'string') {
            data.value[modalName] = payload.data;
        }

        activeModals.value[modalName] = true;

        document.body.setAttribute('data-prevent-scrolling', 'true');
        document.body.setAttribute(`data-modal-${modalName}-open`, 'true');
    }

    return {
        activeModals,
        data,

        close,
        closeAll,
        open
    };
});
